import { Anchor, Badge, Group, Paper, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { TeamDailyNewsItem } from "@msc/shared";

/** `Sun, 24 Aug 2026 …` → `24.08.` — mehr braucht eine Schlagzeile nicht. */
function kurzdatum(raw: string): string {
  const ts = Date.parse(raw);
  if (Number.isNaN(ts)) return "";
  const d = new Date(ts);
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.`;
}

/**
 * Die drei Schlagzeilen des Tages — **untereinander**, nicht als seitwärts
 * scrollende Zeile: In der Leiste war von zwanzig Meldungen eine zu sehen und
 * keine zu lesen. Kundenmeldungen tragen eine Marke, frische ein „neu".
 */
export function NewsTicker({ items }: { items: TeamDailyNewsItem[] }) {
  const { t } = useTranslation();

  return (
    <Paper withBorder p="sm" style={{ height: "100%" }}>
      <Text size="xs" fw={700} c="dimmed" tt="uppercase" mb={6}>
        {t("pages.teamDaily.news")}
      </Text>
      {items.length === 0 ? (
        <Text size="sm" c="dimmed">
          {t("pages.teamDaily.newsEmpty")}
        </Text>
      ) : (
        <Stack gap={8}>
          {items.map((item, i) => (
            <div key={`${item.link}-${i}`}>
              <Group gap={5} wrap="nowrap" mb={1}>
                {/* Der Stern markiert, was seit dem letzten Daily dazukam —
                    beim Durchgehen der Liste ist genau das die Frage. */}
                {item.isFresh && (
                  <Text
                    span
                    size="sm"
                    c="yellow.7"
                    title={t("pages.teamDaily.newsFresh")}
                    style={{ lineHeight: 1 }}
                  >
                    ★
                  </Text>
                )}
                {item.isCustomer && (
                  <Badge size="xs" color="orange" variant="light">
                    {t("common.customer")}
                  </Badge>
                )}
                <Text size="xs" c="dimmed" truncate>
                  {kurzdatum(item.date)}
                  {item.source ? ` · ${item.source}` : ""}
                </Text>
              </Group>
              <Anchor
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                lineClamp={2}
                style={{ lineHeight: 1.35 }}
              >
                {item.title}
              </Anchor>
            </div>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
